exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.coupon-import[data-v-01453fe2] {\n  display: inline-block;\n}\n.excel-upload-input[data-v-01453fe2] {\n  display: none;\n  z-index: -9999;\n}\n.import-container[data-v-01453fe2] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  gap: 10px;\n}\n", ""]);

// exports
